const NETWORK_ERROR_CODES = new Set(['ETIMEDOUT', 'ECONNABORTED', 'ECONNREFUSED', 'EAI_AGAIN', 'ENETUNREACH', 'ECONNRESET', 'ENOTFOUND', 'EPIPE']);
export function isNetworkError(error) {
    if (!error || typeof error !== 'object')
        return false;
    const code = error?.code;
    if (typeof code === 'string' && NETWORK_ERROR_CODES.has(code))
        return true;
    // Axios-style: no response means the request never reached the server
    if ('response' in error && error.response === undefined)
        return true;
    return false;
}
//# sourceMappingURL=NetworkErrorHelper.js.map